import { useMemo } from 'react';

export const useAdjustHoursReportRows = (dataList, columns) => {
  return useMemo(() => {
    return Object.entries(dataList || {}).reduce((result, [key, value]) => {
      const items = value.data.map((item) => {
        const [employee, reason, hours] = item;
        return { employee, reason, hours: hours || '-' };
      });

      const totalHours = items.reduce((acc, row) => {
        const val = +row.hours;
        return Number.isNaN(val) ? acc : acc + val;
      }, 0);

      const footer = Array.isArray(columns)
        ? columns.map((col) => {
            if (col.field === 'hours') return (+totalHours.toFixed(2)).toString();
            return '';
          })
        : undefined;

      result.push({ name: key, items, footer });
      return result;
    }, []);
  }, [dataList, columns]);
};

export default useAdjustHoursReportRows;
